import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './MUI/zh';
import en from './MUI/en';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  messages: {
    zh,
    en
  },
  silentTranslationWarn: true,

});

export default i18n;